import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, TrendingDown } from 'lucide-react';

const StatsCard = ({
  title,
  value,
  total,
  icon: Icon,
  color = 'primary',
  trend,
  trendValue,
  description,
  onClick
}) => {
  const colorClasses = {
    primary: {
      bg: 'bg-primary-100 dark:bg-primary-900/30',
      icon: 'text-primary-600 dark:text-primary-400',
      trend: 'text-primary-600 dark:text-primary-400'
    },
    success: {
      bg: 'bg-success-100 dark:bg-success-900/30',
      icon: 'text-success-600 dark:text-success-400',
      trend: 'text-success-600 dark:text-success-400'
    },
    warning: {
      bg: 'bg-warning-100 dark:bg-warning-900/30',
      icon: 'text-warning-600 dark:text-warning-400',
      trend: 'text-warning-600 dark:text-warning-400'
    },
    danger: {
      bg: 'bg-danger-100 dark:bg-danger-900/30',
      icon: 'text-danger-600 dark:text-danger-400',
      trend: 'text-danger-600 dark:text-danger-400'
    }
  };

  const colors = colorClasses[color] || colorClasses.primary;
  const isPositiveTrend = trendValue ? trendValue >= 0 : trend && !trend.startsWith('-');
  const TrendIcon = isPositiveTrend ? TrendingUp : TrendingDown;

  // Determinar color de tendencia basado en el valor
  const getTrendColor = () => {
    if (!trend) return '';
    if (isPositiveTrend) {
      return 'text-success-600 dark:text-success-400';
    } else {
      return 'text-danger-600 dark:text-danger-400';
    }
  };

  return (
    <motion.div
      whileHover={{ scale: 1.02, y: -2 }}
      className={`card p-6 transition-all duration-200 ${
        onClick ? 'cursor-pointer hover:shadow-lg' : ''
      }`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between mb-4">
        <div className={`p-3 rounded-xl ${colors.bg}`}>
          <Icon className={`w-6 h-6 ${colors.icon}`} />
        </div>

        {trend && (
          <div className={`flex items-center space-x-1 text-sm ${getTrendColor()}`}>
            <TrendIcon className="w-4 h-4" />
            <span className="font-medium">{trend}</span>
          </div>
        )}
      </div>

      <div>
        <h3 className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">
          {title}
        </h3>

        <div className="flex items-end space-x-2">
          <p className="text-2xl font-bold text-gray-900 dark:text-gray-100">
            {value}
          </p>

          {total && (
            <span className="text-sm text-gray-500 dark:text-gray-400 mb-1">
              / {total}
            </span>
          )}
        </div>

        {description && (
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
            {description}
          </p>
        )}
      </div>
    </motion.div>
  );
};

export default StatsCard;